export default class PurchasedGoods {
  constructor() {
    this.entryCode = '';
    this.goodsCode = '';
    this.title = '';
    this.purchasedDate = '';
    this.thumbnail = '';
    this.alternativeText = '';
    this.totalAmount = 0;
    this.quantity = 1;
  }

  public entryCode: string;

  public goodsCode: string;

  public title: string;

  public purchasedDate: string;

  public thumbnail: string;

  public alternativeText: string;

  public totalAmount: number;

  public quantity: number;
}
